module.exports = {
    API_TOKEN: 'dc3b8271892e915ec77a9412f3ff177afc9d3240',
    URL_PATH: 'https://elitecrafthomes.com/api/v1/'
};



//////////////////
// WEBPACK FOOTER
// ./credentials.js
// module id = NfYd
// module chunks = 171